import { ResourceMenus } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/ResourceMenus";

export { ResourceMenus };
